import React, { useEffect, useState, useRef } from 'react';

function Stats() {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  const stats = [
    { value: 20, suffix: "+", label: "Projects & Repos" },
    { value: 550, suffix: "+", label: "DSA Problems Solved" },
    { value: 1000, suffix: "+", label: "Git Commits" },
    { value: 5, suffix: "+", label: "Hackathons" }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div 
      ref={containerRef}
      className="bg-primary dark:bg-gray-800 text-white py-12 md:py-16 shadow-lg rounded-2xl max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-12 relative overflow-hidden"
    >
      {/* Background Decorative patterns */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full blur-xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent/10 rounded-full blur-2xl translate-y-1/2 -translate-x-1/2"></div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center relative z-10">
        {stats.map((stat, idx) => (
          <StatCounter 
            key={idx} 
            value={stat.value} 
            suffix={stat.suffix} 
            label={stat.label} 
            trigger={inView} 
          />
        ))}
      </div>
    </div>
  );
}

function StatCounter({ value, suffix, label, trigger }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!trigger) return;

    let start = 0;
    const end = value;
    const duration = 1500; // ms
    const increment = Math.ceil(end / (duration / 30));
    
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 30);

    return () => clearInterval(timer);
  }, [trigger, value]);

  return (
    <div className="flex flex-col items-center">
      <span className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-accent">
        {count}{suffix}
      </span>
      <span className="text-xs md:text-sm lg:text-base font-semibold text-gray-200 mt-2 uppercase tracking-wide">
        {label}
      </span>
    </div>
  );
}

export default Stats;
